var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.authpage)?_c('HeaderComp'):_vm._e(),(_vm.nav)?_c('main',{staticClass:"container-fluid"},[_c('Nav')],1):_vm._e(),_c('vue-page-transition',{attrs:{"name":!_vm.authpage ? 'fade' : ''}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }